import clsx from 'clsx';
import { LoadingSpinner, Stack } from 'components';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFilesPreview } from 'store/files/filesActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ReactComponent as MoreIcon } from 'assets/svg/more_icon.svg';

import style from './files.module.scss';
import FilesModal from './filesModal';

const Files = () => {
  const { clientId } = useParams();
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [showSection, setShowSection] = useState(true);
  const { filesPreviewList, filesPreviewListLoading } = useAppSelector((state) => state.files);

  useEffect(() => {
    if (clientId) {
      dispatch(getFilesPreview({ clientId }));
    }
  }, []);

  const handleModalOpen = () => setOpen(true);
  const handleToggleSection = () => setShowSection(!showSection);

  return (
    <Stack width="100%" mb="16px" data-test-id="files-section">
      <Stack className={style.wrapper} flexDirection="row">
        <p className={style.title}>Files</p>
        <div>
          <span onClick={handleModalOpen} className={clsx('material-icons-outlined', style.icon)}>
            open_in_new
          </span>
          <span
            onClick={handleToggleSection}
            className={clsx('material-icons-outlined', style.icon)}
          >
            {showSection ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
          </span>
        </div>
      </Stack>
      {open && <FilesModal open={open} setOpen={setOpen} />}
      {!showSection ? null : filesPreviewListLoading && !open ? (
        <Stack width="100%" height="100%" justifyContent="center" alignItems="center" mt="16px">
          <LoadingSpinner />
        </Stack>
      ) : filesPreviewList?.length > 0 ? (
        <Stack gap="8px" mx="12px" mt="12px">
          {filesPreviewList
            .map((item, index) =>
              index >= 3 ? (
                <span key={item.id}>
                  <MoreIcon />
                </span>
              ) : (
                <Stack
                  flexDirection="row"
                  justifyContent="space-between"
                  fontSize="12px"
                  lineHeight="140%"
                  key={item.id}
                  onClick={handleModalOpen}
                  sx={{ cursor: 'pointer' }}
                >
                  <div className={style.fileName}>{item.fileName || '-'}</div>
                  <div style={{ fontVariantNumeric: 'tabular-nums' }}>
                    {item.uploadDateTime ? dayjs(item.uploadDateTime).format('M/DD/YY') : '-'}
                  </div>
                </Stack>
              )
            )
            .slice(0, 4)}
        </Stack>
      ) : (
        <Stack ml="16px" mt="12px" fontSize="12px">
          No files
        </Stack>
      )}
    </Stack>
  );
};

export default Files;
